import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteItem, fetchData, handleAddItem, handleFilter, handleUpdateItem } from "../../utils/data";
import { Hall, PaginationType, Review, Stay } from "../../types";
import i18n from "../../i18n";
const lang = i18n.language === "ar" ? "ar" : "en";
export const fetchHalls = createAsyncThunk("get/halls", async ({ userId, page }: { userId: number | string | undefined, page: number }) => {
    const data = await fetchData(`Place/getHalls?lang=${lang}&userId=${userId}&page=${page}`, false, true);
    return data;
});
export const fetchStays = createAsyncThunk("get/stays", async ({ userId, page }: { userId: number | string | undefined, page: number }) => {
    const data = await fetchData(`Place/getStays?lang=${lang}&userId=${userId}&page=${page}`, false, true);
    return data;
});
export const fetchPopularStays = createAsyncThunk("get/PopularStays", async ({ userId, page }: { userId: number | string | undefined, page: number }) => {
    const data = await fetchData(`Place/getPopularStays?lang=${lang}&userId=${userId}&page=${page}`, false, true);
    return data;
});
export const fetchPopularHalls = createAsyncThunk("get/PopularHalls", async ({ userId, page }: { userId: number | string | undefined, page: number }) => {
    const data = await fetchData(`Place/getPopularHalls?lang=${lang}&userId=${userId}&page=${page}`, false, true);
    return data;
});
export const fetchHallsOffers = createAsyncThunk("get/hallsOffers", async ({ userId, page }: { userId: number | string | undefined, page: number }) => {
    const data = await fetchData(`Place/getHallsOffer?lang=${lang}&userId=${userId}&page=${page}`, false, true);
    return data;
});
export const fetchStaysOffers = createAsyncThunk("get/staysOffers", async ({ userId, page }: { userId: number | string | undefined, page: number }) => {
    const data = await fetchData(`Place/getStaysOffer?lang=${lang}&userId=${userId}&page=${page}`, false, true);
    return data;
});
export const fetchPlaceDetails = createAsyncThunk("get/Place", async ({ placeId, userId }: { placeId: number, userId?: string | number|null }) => {
    const data = await fetchData(`Place/getPlaceDetails?placeId=${placeId}&userId=${userId}&lang=${lang}`);
    return data;
});
export const fetchPlaceDetailsAdmin = createAsyncThunk("get/PlaceAdmin", async (placeId: number) => {
    const data = await fetchData(`Place/getPlaceDetailsWithAllData?placeId=${placeId}`, true);
    return data;
});
export const fetchCategories = createAsyncThunk("get/Categories", async () => {
    const data = await fetchData(`Category/getCategories?lang=${lang}`);
    return data;
});
export const fetchSubCategoryByCategory = createAsyncThunk("get/subCategories", async (categoryId: number) => {
    const data = await fetchData(`SubCategory/getSubCategoryByCategory?categoryId=${categoryId}&lang=${lang}`);
    return data;
});
export const fetchPlaceReviews = createAsyncThunk("get/PlaceReviews", async (placeId: number) => {
    const data = await fetchData(`Review/getPlaceReviews?placeId=${placeId}`);
    return data;
});
export const addPlace = createAsyncThunk("post/place", async (placeData: any) => {
    const res = await handleAddItem(placeData, "Place/addPlace", "POST");
    return res.data;
});
export const filterPlaces = createAsyncThunk("post/filterPlaces", async ({ filters, page }: { filters: any, page: number }) => {
    const response = await handleFilter(filters, `Place/filterPlaces?lang=${lang}&page=${page}`, "POST");
    return response;
});
export const updatePlace = createAsyncThunk("PUT/place", async ({ id, data }: { id: number, data: any }) => {
    await handleUpdateItem(data, `Place/editPlace?placeId=${id}`, "PUT");

});
export const deletePlace = createAsyncThunk("delete/place", async (id: number) => {
    await deleteItem(`Place/deletePlace?placeId=`, id);
    return id;
});
export const deletePlaceImage = createAsyncThunk("delete/placeImage", async ({ placeId, imageId }: { placeId: number, imageId: number }) => {
    await deleteItem(`Place/deletePlaceImage?placeId=${placeId}&imageId=`, imageId,);

});
export const deletePlaceServicee = createAsyncThunk("delete/placeService", async ({ placeId, serviceId }: { placeId: number, serviceId: number }) => {
    await deleteItem(`Place/deletePlaceService?placeId=${placeId}&serviceId=`, serviceId,);
});
interface articleState {
    halls: Hall[];
    stays: Stay[];
    reviews: Review[]
    popularHalls: Hall[];
    popularStays: Stay[];
    hallsOffer: Hall[];
    staysOffer: Stay[];
    searchRuselt: Hall[] | Stay[];
    place: Stay | Hall | null;
    pagination: PaginationType | null,
    staysPagination: PaginationType | null,
    subCategories: any;
    categories: any;
    loading: boolean;
    error: string;
}

const initialState: articleState = {
    halls: [],
    stays: [],
    popularHalls: [],
    reviews: [],
    popularStays: [],
    pagination: null,
    staysPagination:null,
    hallsOffer: [],
    staysOffer: [],
    searchRuselt: [],
    subCategories: [],
    categories: [],
    place: null,
    loading: false,
    error: ""
};

const placeSlice = createSlice({
    name: "placeSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch halls
            .addCase(fetchHalls.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchHalls.fulfilled, (state, action) => {
                state.loading = false;
                state.halls = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            // Fetch stay
            .addCase(fetchStays.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchStays.fulfilled, (state, action) => {
                state.loading = false;
                state.stays = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(updatePlace.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(updatePlace.fulfilled, (state) => {
                state.loading = false;
               
            })
            // Fetch popular halls
            .addCase(fetchPopularHalls.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchPopularHalls.fulfilled, (state, action) => {
                state.loading = false;
                state.popularHalls = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            // Fetch stay
            .addCase(fetchPopularStays.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchPopularStays.fulfilled, (state, action) => {
                state.loading = false;
                state.popularStays = action.payload.data;
                state.staysPagination = action.payload.pagination;
            })
            // Fetch halls offer
            .addCase(fetchHallsOffers.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchHallsOffers.fulfilled, (state, action) => {
                state.loading = false;
                state.hallsOffer = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            // Fetch stay offer
            .addCase(fetchStaysOffers.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchStaysOffers.fulfilled, (state, action) => {
                state.loading = false;
                state.staysOffer = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            // Fetch placeDetails
            .addCase(fetchPlaceDetails.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchPlaceDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.place = action.payload;
            })
            // Fetch placeDetails for admin
            .addCase(fetchPlaceDetailsAdmin.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchPlaceDetailsAdmin.fulfilled, (state, action) => {
                state.loading = false;
                state.place = action.payload;
            })
            // Fetch subCategories
            .addCase(fetchSubCategoryByCategory.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchSubCategoryByCategory.fulfilled, (state, action) => {
                state.loading = false;
                state.subCategories = action.payload;
            })
            // FetchCategories
            .addCase(fetchCategories.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(fetchCategories.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload;
            })
            .addCase(fetchPlaceReviews.fulfilled, (state, action) => {
                state.reviews = action.payload;
            })
            // filter
            .addCase(filterPlaces.pending, (state) => {
                state.loading = true;
                state.error = "";
            })
            .addCase(filterPlaces.fulfilled, (state, action) => {
                state.loading = false;
                state.searchRuselt = action.payload?.data;
                state.pagination = action.payload?.pagination;
            })

            // Delete
            .addCase(deletePlace.fulfilled, (state, action) => {
                const existsInHalls = state.halls.some(item => item.id === action.payload);
                if (existsInHalls) {
                    state.halls = state.halls.filter(item => item.id !== action.payload);
                } else {
                    state.stays = state.stays.filter(item => item.id !== action.payload);
                }
            })
    }
});

export default placeSlice.reducer;
